import React from 'react';
import './index.css'
import { Tag } from 'antd-mobile';
class TagItem extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            index: 0,
            selectedArr:[],
            selected: true
        }
    }
    componentDidMount(){
        this.props.onRef(this)
    }
    clearSelect(){
        this.setState({
            selectedArr:[],
        })
    }
    handleChange (selected, sid,id){
        const {changeCateId} = this.props;
        new Promise((r,j)=>{
            this.state.selectedArr.includes(sid) ?
                this.state.selectedArr.splice(this.state.selectedArr.indexOf(sid), 1)
                :
                this.setState({
                    selected,
                    index: sid,
                    selectedArr: this.state.selectedArr.concat(sid)
                },r);
        }).then(()=>{changeCateId(this.state.selectedArr)})


    }

    render() {
      const {data} = this.props;
        return (
          <div>
           {
              data&&data.size!=0?
              data.map((item,index)=>{
                return (
                   <div className="tag-item" key={index}>
                      <div className="tag-row">
                        <span className="hd">{item.get('name')}</span>
                      </div>
                      <div className="tag-row"> 
                        {/*<Tag  */}
                            {/*selected={this.state.selected&&this.state.index===item.get('id')}*/}
                            {/*onChange={selected => this.handleChange( selected,item.get('id'),item.get('id'))}> 不限 </Tag>*/}
                 
                      {
                        item.get('childs')&&item.get('childs').size!=0?
                        item.get('childs').map((s,i)=>{
                         return <Tag 
                            key={i} 
                            selected={this.state.selected&&this.state.selectedArr.find((item)=>item===s.get('id'))}
                            onChange={selected => this.handleChange( selected,s.get('id'),item.get('id'))}>
                             {s.get('name') }
                          </Tag>
                        }):
                        '暂无'
                      }
                        
                        
                      </div>
                    </div>
                  )
              }):null
               
            }
            </div>
           )
    }
     
}
export default TagItem;